import { userConstants } from "../../constant";

const initialState = {
  brands: [],
  sizes: [],
  conditions: [],
  manufacturer_countries: [],
  certifications: [],
};

export function filterOptions(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_FILTER_OPTIONS:
      return {
        brands: action.payload.brands || [],
        sizes: action.payload.sizes || [],
        conditions: action.payload.conditions || [],
        manufacturer_countries: action.payload.manufacturer_countries || [],
        certifications: action.payload.certifications || [],
      };

    default:
      return state;
  }
}
